var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.upgradeType)?_c('div',{staticClass:"upgrade-container"},[_c('iframe',{attrs:{"id":"upgframe","src":_vm.callURL()}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }